export default __webpack_public_path__ + "static/media/aboutimg.4c04dc59.svg";